import { render, staticRenderFns } from "./sba-modal.vue?vue&type=template&id=bb2b77a0&scoped=true&"
import script from "./sba-modal.vue?vue&type=script&lang=js&"
export * from "./sba-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2b77a0",
  null
  
)

export default component.exports